import React, { useState, useEffect} from "react"
import {Antd, Form, Button } from 'components'
import * as Yup from "yup"
import debounce from 'debounce'
import * as S from './styles'
import { isDesktop } from '../../utility'
import { usePrevious} from '../../customHooks'
import theme from "../../style/theme";
import { requestPlan } from '../../api'
const Modal = Antd.Modal
const Steps = Antd.Steps
const Table = Antd.Table
const Icon = Antd.Icon

const { Step } = Steps
function getFinalStep(activePlan){
  if(!activePlan) return null
  if(activePlan.key === "enterprise") return 1

  return 2
}

export default ({activePlan, onCancel, industries, pricingModalSummaryTable, pricingStepsLabel,primary, currency, pricingFormInputs, pricingThankyouPage}) => {
  const [formValues, setFormValues] = useState({})
  const [step, setStep] = useState(0)
  const [isLoading, setLoading] = useState(null)
  const [error, setError] = useState(null)
  const [isSummaryCardActive, activeSummaryCard] = useState(null)
  const prevFormValues = usePrevious(formValues)
  const handleSetFormValuesDebounced = debounce(handleSetFormValues, 200);

  const finalStep = getFinalStep(activePlan)

  function handleSetFormValues(e){
    if(e && e.values && (JSON.stringify(prevFormValues.values) !== JSON.stringify(e.values))){
      setFormValues(e.values)
    }
  }

  function getTotalPrice({formValues, activePlan}){
    if(!activePlan || activePlan.key === "enterprise") return null
    
    const planDefaultPrice = activePlan.price


    const itemsTotalPrice =  activePlan.items.reduce((acc, val) => {
      const itemValueFromSlider = formValues[val.name] || 0
      const itemValuePrice = (val && val.values && val.values.find(e => e.value === itemValueFromSlider)) || 0
      const price = itemValuePrice && itemValuePrice.price
      if(!price) return acc
      return price + acc
    }, 0)


    const modulesTotalPrice = formValues.additionalModules ? formValues.additionalModules.reduce((acc,val) => acc + Number(val), 0) : 0


    return planDefaultPrice + itemsTotalPrice + modulesTotalPrice
  }


  async function handleSendRequest(){
    setLoading(true)
    await requestPlan(formValues)
    setLoading(false)
  }


 

  function handleModalClose(){
    onCancel() 
    setStep(0)
  }

  useEffect(() => {
    setLoading(true)

    let timer = null

    if(step === finalStep){
      handleSendRequest()
    } else {
      timer = setTimeout(() => {
        setLoading(false)
      }, 1000);
    }

    return () => clearTimeout(timer)
  },[finalStep, step])


  useEffect(() => {
    if(!isLoading) {
      if(typeof document === "undefined") return
      const element = document.getElementsByClassName("ant-modal-wrap")
      if(!element || !element.length) return
      document.getElementsByClassName("ant-modal-wrap")[0].scrollTo(0,0)
    }
  },[isLoading])

  const totalPrice = getTotalPrice({formValues, activePlan})

  return (
    <Modal
      visible={activePlan}
      onCancel={handleModalClose}
      footer={null}
      width={isDesktop 
          ? (window.innerWidth - 64)
          : (typeof window !== "undefined" ?  (window.innerWidth) : 0)}
      height={isDesktop 
          ? (window.innerHeight - 64)
          : (typeof window !== "undefined" ?  (window.innerHeight) : 0)}
      style={{
        top: isDesktop ? 32 : 0,
      }}
    >


    <S.StepsWrapper>
      <Steps current={step}>
        {pricingStepsLabel.filter((e, index) => {
          if(index === 0 && activePlan && activePlan.key==="enterprise") return null
          return e
        }).map(step => <Step title={step} />)}
      </Steps>
    </S.StepsWrapper>
    {activePlan && <S.ModalTitle color={activePlan.color}>{activePlan.title}</S.ModalTitle>}

    {
      activePlan
      
      && (
        <S.ModalInner>
          {isLoading && <S.Loading><Icon type="loading" /></S.Loading>}
          {
            step === finalStep && !error && <S.Thankyou>
              <p>{pricingThankyouPage[0]}</p>
              <p>{pricingThankyouPage[1]},  <strong>{formValues.firstname}</strong></p>
              <p>{pricingThankyouPage[2]}</p>
              <p>{pricingThankyouPage[3]}   <span>godoo</span></p>
            </S.Thankyou>   
          }

          { (step === finalStep) && error &&
            <S.Thankyou>
            <p>Something is wrong</p>
              <p>try it later</p>
            </S.Thankyou>   
          }

          
          { step !== finalStep && activePlan.key === "enterprise" && <>
              <Form 
                layout={{
                  labelCol: {
                    xs: { span: 12 },
                    sm: { span: 10  }
                  },
                  wrapperCol: {
                    xs: { span: 12 },
                    sm: { span: 8 }
                  }
                }}
                submitLabel={primary.find(e => e.key === "complete").label}
                onSubmit={() => setStep(step + 1)}
                onChange={handleSetFormValuesDebounced}
                inputs={[

                  pricingFormInputs[3], // DIVIDER 2
                  ...pricingFormInputs.slice(4).map(e => ({
                    ...e,
                    condition: (values) => { 
                      if(values.userType === "private"){
                        if(e.name === "companyName") return false
                        if(e.name === "position") return false
                      }
                      return true
                    }
                  })),
                  {
                    type: "text",
                    name: "activePlan",
                    hidden: true,
                  }
                ].filter(e => e)}


                initialValues={{
                  activePlan: activePlan.key,
                  userType: 'private'
                }}
                validationSchema={Yup.object().shape({
                  firstname: Yup.string().required(pricingFormInputs.find(e => e.name === "firstname").required),
                  lastname: Yup.string().required(pricingFormInputs.find(e => e.name === "lastname").required),
                  email: Yup.string().required(pricingFormInputs.find(e => e.name === "email").required),
                  companyName: Yup.string().when('userType', {
                    is: (userType) => userType === "company",
                    then: Yup.string().required(pricingFormInputs.find(e => e.name === "companyName").required),
                  }),
                  privacy: Yup.string().required(pricingFormInputs.find(e => e.name === "privacy").required)
                })}
              />
</>
          }


          
          { step !== finalStep && activePlan.key !== "enterprise" && <>

            <S.ModalColumn left>
            <S.SummaryCard > 
              <S.SummaryCardHeader>
                <S.SummaryCardTitle>Your plan</S.SummaryCardTitle>
               
                {
                  <S.SummaryCardCollapser>
                    <Button size="small" type="ghost" onClick={() => activeSummaryCard(!isSummaryCardActive)} icon={isSummaryCardActive ? "down" : "up"}></Button>
                  </S.SummaryCardCollapser>
                }
                
              </S.SummaryCardHeader>
              <S.SummaryCardContent isSummaryCardActive={isSummaryCardActive}>
              <S.SummaryCardText>{activePlan.text}</S.SummaryCardText>
              <S.SummaryCardItems>
                <Table
                  size="small"
                  bordered
                  pagination={false}
                  columns={[
                    {
                      title: pricingModalSummaryTable.find(e => e.key === "element").label,
                      dataIndex: 'element',
                      key: 'element',
                    },
                    {
                      title: pricingModalSummaryTable.find(e => e.key === "included").label,
                      dataIndex: 'included',
                      key: 'included',
                    },
                    {
                      title: pricingModalSummaryTable.find(e => e.key === "added").label,
                      dataIndex: 'added',
                      key: 'added',
                    },
                    {
                      title: pricingModalSummaryTable.find(e => e.key === "total").label,
                      dataIndex: 'total',
                      key: 'total',
                      
                    },
                    {
                      title: pricingModalSummaryTable.find(e => e.key === "price").label,
                      dataIndex: 'price',
                      key: 'price',
                      render: e => <>{currency} {e}</>
                    },
                  ]}
                  dataSource={[
                    // rows connected to the activePlanItems
                    ...activePlan.items.map(({name, values, included}) => {
                      const itemValueFromSlider = formValues[name] || 0
                      const itemValuePrice = (values && values.find(e => e.value === itemValueFromSlider)) || 0
                      return {
                        element: name,
                        included,
                        added: itemValueFromSlider,
                        total: included + itemValueFromSlider,
                        price: itemValuePrice && itemValuePrice.price
                      }
                    }),
                    // rows connected to the additionalModules (coming from the multi select)
                    ...pricingFormInputs.find(e => e.name === "additionalModules").items.map(additionalModuleRow => {
                      const hasModuleBeenAdded = (formValues["additionalModules"] && formValues["additionalModules"].find(e => e === additionalModuleRow.value))
                      return {
                        element: additionalModuleRow.label,
                        included: 0,
                        added: hasModuleBeenAdded ? 1 : 0,
                        total: hasModuleBeenAdded ? 1 : 0,
                        price: additionalModuleRow.value * (hasModuleBeenAdded ? 1 : 0)
                      }

                    })
                  ]}
                />
              </S.SummaryCardItems>
              <S.SummaryCardFooter>
                <S.PlanPriceWrapper>
                  <S.PlanPriceCurrency>{currency}</S.PlanPriceCurrency>
                  <S.PlanPrice>{totalPrice}</S.PlanPrice>
                  <S.PlanPricePost>{activePlan.pricePost}</S.PlanPricePost>
                </S.PlanPriceWrapper>
              </S.SummaryCardFooter>
              </S.SummaryCardContent>
            </S.SummaryCard>
          </S.ModalColumn>
            

            <S.ModalColumn>
              <Form 
                layout={{
                  labelCol: {
                    xs: { span: 12 },
                    sm: { span: 10,  }
                  },
                  wrapperCol: {
                    xs: { span: 12 },
                    sm: { span: 14 }
                  }
                }}
                showSubmit={step === 1}
                submitLabel={primary.find(e => e.key === "complete").label}
                onSubmit={() => setStep(step + 1)}
                onChange={handleSetFormValuesDebounced}
                inputs={[
                  // STEP 0
                  step === 0 && pricingFormInputs[0], // DIVIDER 0
                  ...activePlan.items.map(({name, values}) => values && ({
                    label: `${name}`,
                    type: "slider",
                    step: null,
                    marks: values.reduce((acc,val, index) => { 
                      return {
                        ...acc,
                        [val.value]: (index === 0 || index === values.length - 1 ) && val.value
                      }}, {}
                    ),
                    name,
                    min: values[0].value,
                    max: values[values.length -1].value,
                    hidden: !(step === 0)
                  })).filter( e => e),
                  step === 0 && {
                    label: pricingFormInputs[1].label,
                    type:  pricingFormInputs[1].type,
                    orientation:  pricingFormInputs[1].orientation,
                  },  // DIVIDER 1
                  {
                    label: "Select your industry",
                    type: "select",
                    name: "industry",
                    items: [
                      ...industries.map(e => ({label: e.title, value: e.slug})),
                      {
                        label: 'Others',
                        value:  null
                      },
                    ],
                    hidden: !(step === 0)
                  },
                  step === 0 && {
                    label: pricingFormInputs[2].label,
                    type:  pricingFormInputs[2].type,
                    items:  pricingFormInputs[2].items,
                    name:  pricingFormInputs[2].name,
                    mode:"multiple"
                  },  
                  // STEP 1
                  step === 1 && pricingFormInputs[3], // DIVIDER 2
                  ...pricingFormInputs.slice(4).map(e => ({
                    ...e,
                    hidden: !(step === 1),
                    condition: (values) => { 
                
                      if(values.userType === "private"){
                        if(e.name === "companyName") return false
                        if(e.name === "position") return false
                      }
                      return true
                    }
                  })),
                  {
                    type: "text",
                    name: "activePlan",
                    hidden: true,
                  }
                ].filter(e => e)}


                initialValues={{
                  activePlan: activePlan.key,
                  industry: null,
                  userType: 'private'
                }}
                validationSchema={Yup.object().shape({
                  firstname: Yup.string().required(pricingFormInputs.find(e => e.name === "firstname").required),
                  lastname: Yup.string().required(pricingFormInputs.find(e => e.name === "lastname").required),
                  email: Yup.string().required(pricingFormInputs.find(e => e.name === "email").required),
                  companyName: Yup.string().when('userType', {
                    is: (userType) => userType === "company",
                    then: Yup.string().required(pricingFormInputs.find(e => e.name === "companyName").required),
                  }),
                  privacy: Yup.string().required(pricingFormInputs.find(e => e.name === "privacy").required)
                })}
              />
            </S.ModalColumn>
            <S.Buttons>
              <Button size="regular" disabled={step === 0} color="grey" onClick={() => setStep(step - 1)}>{primary.find(e => e.key === "back").label}</Button>
              {step === 0 && <Button color={theme.colors.thirdary} size="regular" onClick={() => setStep(step + 1)}>{primary.find(e => e.key === "next").label}</Button>}
            </S.Buttons>
        </>
        }
        </S.ModalInner>
      )
    }
    </Modal>
  )
}